import React, {Component} from "react";
import {Field, reduxForm} from "redux-form/immutable";
import ActionButton from "../../components/ActionButton";
import FormFieldsTable from "../../components/forms/FormFieldsTable";
import DropDownInputField from "../../components/forms/DropDownInputField";
import {fromJS} from "immutable";
import FormError from "../../components/forms/FormError";

const forceOptions = fromJS([
  {value: "normal", title: "Retry only failed reservation"},
  {value: "force", title: "Force new stock reservation"}
])

class RetryStockReservationForm extends Component {

  render() {
    let {errors, handleSubmit, submit, submitting} = this.props;
    let submitLabel = submitting ? "Standby..." : "Submit"; 
    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <FormFieldsTable>
            <Field 
              label="Method"
              name="method"
              component={DropDownInputField}
              data={forceOptions}
              valueKey="value"  
              titleKey="title"
              showBlank={false}
              serverError={this.props.errors.method}
              />
          </FormFieldsTable>          
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton label={submitLabel} onClick={submit} active={!submitting} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
        </div>
      </form>
    )
  }
}

const ReduxForm = reduxForm({
  form: "RetryStockReservationForm"
})(RetryStockReservationForm);

ReduxForm.defaultProps = {
  message: "Confirm message"
}

export default ReduxForm;